export default {
  SET_TABLE_DATA: 'SET_TABLE_DATA',
  SET_LATEST_MATCH_DATA: 'SET_LATEST_MATCH_DATA',
};



// WEBPACK FOOTER //
// ./src/store/mutation-types.js